<template>
  <main class="flex-1 overflow-auto pt-16 lg:ml-64 lg:pt-0">
    <div
      class="min-h-full container max-w-[115rem] mx-auto px-4 py-6 sm:px-6 flex flex-col"
    >
      <!-- <div class=""> -->
      <slot />
      <!-- </div> -->
    </div>
  </main>
</template>
